/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Audio_Embed_Export_Source_Option_OriginalInputs */

const en_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
};

const fr_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
};

const de_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
};

const it_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Originale • ${i?.label}`)
};

const ru_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Оригинал • ${i?.label}`)
};

const es_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
};

const zh_cn2_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`原文 • ${i?.label}`)
};

const ja_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`オリジナル • ${i?.label}`)
};

const hi_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मूल • ${i?.label}`)
};

const pt_pt2_audio_embed_export_source_option_original = /** @type {(inputs: Audio_Embed_Export_Source_Option_OriginalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Original • ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Original • {label}" |
*
* @param {Audio_Embed_Export_Source_Option_OriginalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_source_option_original = /** @type {((inputs: Audio_Embed_Export_Source_Option_OriginalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Source_Option_OriginalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_source_option_original(inputs)
	if (locale === "de") return de_audio_embed_export_source_option_original(inputs)
	if (locale === "it") return it_audio_embed_export_source_option_original(inputs)
	if (locale === "ru") return ru_audio_embed_export_source_option_original(inputs)
	if (locale === "es") return es_audio_embed_export_source_option_original(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_source_option_original(inputs)
	if (locale === "ja") return ja_audio_embed_export_source_option_original(inputs)
	if (locale === "hi") return hi_audio_embed_export_source_option_original(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_source_option_original(inputs)
	return en_audio_embed_export_source_option_original(inputs)
});